import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../utils/api.service';
import { QuestionGroup, Survey } from '../../models';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class SurveyService {

  path = 'surveys';

  constructor(
    private apiService: ApiService,
  ) {}

  get(id: string, lang: string = ''): Observable<Survey> {
    return this.apiService.get(`${this.path}/${id}`, new HttpParams(), lang);
  }

  getAll(organization: number = null, isEnabled: boolean = null, topic: string = null): Observable<Survey[]> {
    let query: HttpParams = new HttpParams();
    if (organization) {
      query = query.append('organization', `${organization}`);
    }

    if (isEnabled) {
      query = query.append('isEnabled', `${isEnabled}`);
    }

    if (topic) {
      query = query.append('topic', topic);
    }

    return this.apiService.get(this.path, query)
      .pipe(
        map(results => results.map(survey => new Survey(survey))),
      );
  }

  getQuestionGroups(id: string, lang: string = ''): Observable<QuestionGroup[]> {
    return this.apiService.get(`${this.path}/${id}/question_groups`, new HttpParams(), lang);
  }

  save(survey, lang: string = ''): Observable<Survey> {
    if (survey.id) {
      return this.apiService.put(`${this.path}/${survey.id}`, survey, lang);
    } else {
      return this.apiService.post(`${this.path}`, survey, lang);
    }
  }
}
